import { Row, Typography } from "@commonlibs";
import { ReactNode } from "react";
import { Container, DeleteFileButton } from "./UploadedFileItem.styles";
import DeleteIcon from "ui/common/icons/DeleteIcon";

interface UploadedFileItemProps {
    file: File | string;
    onDelete: () => void;
    deleteIcon?: ReactNode;
    testId?: string;
}

const UploadedFileItem: React.FC<UploadedFileItemProps> = ({
    file,
    onDelete,
    deleteIcon = <DeleteIcon />,
    testId = "uploaded-file-item",
}) => {
    const fileName = file instanceof File ? file.name : file;

    return (
        <Container>
            <Row justifyContent="space-between" css={{ padding: "5px 0px" }}>
                <Typography variant="body2Regular">
                    <span title={fileName}>{fileName}</span>
                </Typography>

                <DeleteFileButton data-testid={testId} onClick={onDelete}>
                    {deleteIcon}
                </DeleteFileButton>
            </Row>
        </Container>
    );
};

export default UploadedFileItem;